interface ILinkProps {
  color?: string;
}

const Link: React.FC<ILinkProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={22}
      height={21}
      fill="none"
      {...props}
    >
      <path
        fill={props.color || "#5F5F5F"}
        d="m10.662 3.413 1.875-1.875a5.25 5.25 0 1 1 7.425 7.425l-3.75 3.75a5.25 5.25 0 0 1-7.425 0 1.126 1.126 0 0 1 .804-1.892c.291-.005.573.103.787.302a2.997 2.997 0 0 0 4.245 0l3.75-3.75a3.003 3.003 0 0 0-4.246-4.245l-1.875 1.875a1.127 1.127 0 0 1-1.891-.804 1.126 1.126 0 0 1 .301-.786Zm-7.035 14.46a2.997 2.997 0 0 0 4.245 0l1.875-1.876a1.127 1.127 0 0 1 1.892.804c.005.291-.103.573-.301.787l-1.876 1.874A5.248 5.248 0 0 1 .9 17.76a5.25 5.25 0 0 1 1.138-5.722l3.75-3.75a5.25 5.25 0 0 1 7.426 0 1.126 1.126 0 0 1-1.59 1.59 2.997 2.997 0 0 0-4.246 0l-3.75 3.75a2.996 2.996 0 0 0 0 4.245Z"
      />
    </svg>
  );
};

export default Link;
